import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import TopLabel from './TopLabel';

@inject('sidebarStore')
@observer
class TopLabels extends Component {
  render() {
    const { firstInSidebar } = this.props
    const anyLabels = !!this.props.sidebarStore.labels.length;

    return (
      <>
        {
          anyLabels && (
            <div className={`flex flex-col mb-12 ${firstInSidebar ? 'mt-0' : 'mt-2'}`}>
              <p className='text-2xl font-bold mb-5 leading-none'>Top Labels</p>
              {
                this.props.sidebarStore.labels.map((label, i) => (
                  <TopLabel key={i} label={label} number={i} />
                ))
              }
            </div>
          )
        }
      </>
    )
  }
}

export default TopLabels;
